export const devEnvFlags = {
    geolocationBannerActions: false,
    parkingDiscountBanner: false,
    parkingPackages: true,
    communityParkings: false,
    partnersIntegration: true,
    gates: true,
};
